(function() {
  function loadScript(src, cb) {
    var s = document.createElement('script');
    s.src = src;
    s.onload = cb;
    document.head.appendChild(s);
  }
  function loadStyle(href) {
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = href;
    document.head.appendChild(l);
  }

  var items = [];
  var isReady = false;
  var isOpen = false;

  function getHighResSrc(img) {
    if (img.srcset) {
      var parts = img.srcset.split(',').map(function(p) { return p.trim(); });
      var last = parts[parts.length - 1].split(' ')[0];
      if (last) return last;
    }
    return img.src;
  }

  function applyPswpStyles() {
    var el = document.querySelector('.pswp');
    if (!el) return;
    document.body.appendChild(el);
    el.style.setProperty('position', 'fixed', 'important');
    el.style.setProperty('top', '0', 'important');
    el.style.setProperty('left', '0', 'important');
    el.style.setProperty('width', '100vw', 'important');
    el.style.setProperty('height', '100vh', 'important');
    el.style.setProperty('z-index', '2147483647', 'important');
    el.style.setProperty('background', '#000', 'important');
    el.style.setProperty('display', 'block', 'important');
    el.style.setProperty('opacity', '1', 'important');
    el.style.setProperty('contain', 'none', 'important');
    var bg = el.querySelector('.pswp__bg');
    if (bg) {
      bg.style.setProperty('background', '#000', 'important');
      bg.style.setProperty('opacity', '1', 'important');
    }
  }

  function prepareItems() {
    var mediaItems = document.querySelectorAll('.product__media-list .product__media-item');
    items = [];
    mediaItems.forEach(function(item) {
      var img = item.querySelector('img');
      if (!img) return;
      var src = getHighResSrc(img);
      
      // Mantém a sua correção da imagem perfeitamente quadrada (1200x1200)
      var squareSize = (img.naturalWidth && img.naturalWidth > 0) ? (img.naturalWidth * 2) : 2400;
      
      items.push({ 
        src: src, 
        width: squareSize, 
        height: squareSize,
        alt: img.alt || '' 
      });
      img.style.cursor = 'zoom-in';
    });
  }

  function openLightbox(index) {
    if (isOpen) return;
    if (!items.length) prepareItems(); 
    isOpen = true;
    window._pswpOpen = true;

    var pswp = new PhotoSwipe({
      dataSource: items,
      index: index,
      loop: true,
      zoom: true,
      pinchToClose: true,
      bgOpacity: 1,
      showHideAnimationType: 'none',
      padding: { top: 40, bottom: 40, left: 20, right: 20 }
    });

    pswp.on('beforeOpen', function() { document.body.style.overflow = 'hidden'; });
    pswp.on('uiRegister', function() {
      applyPswpStyles();
      setTimeout(applyPswpStyles, 50);
    });
    pswp.on('destroy', function() {
      document.body.style.overflow = '';
      window._pswpOpen = false;
      setTimeout(function() { isOpen = false; }, 300);
    });

    pswp.init();
    setTimeout(applyPswpStyles, 10);
  }

  /* ========================================================== */
  /* BLOQUEIO IMEDIATO DO ZOOM NATIVO (O SEGREDO ESTÁ AQUI)     */
  /* ========================================================== */
  document.addEventListener('click', function(e) {
    var targetBtn = e.target.closest('.product__media-zoom-button, .product__media-toggle');
    var targetImg = e.target.closest('.product__media-item img');

    // Se o cliente clicar na imagem da blusa...
    if (targetBtn || targetImg) {
      // Impede o Zoom original da Shopify de abrir
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      if (isOpen) return;

      var mediaItem = (targetBtn || targetImg).closest('.product__media-item');
      var mediaItems = document.querySelectorAll('.product__media-list .product__media-item');
      var idx = Array.from(mediaItems).indexOf(mediaItem);
      var finalIdx = idx >= 0 ? idx : 0;

      // Se o PhotoSwipe já carregou, abre ele. Se não, espera carregar e abre.
      if (isReady) {
        openLightbox(finalIdx);
      } else {
        initLightbox(function() {
          openLightbox(finalIdx);
        });
      }
    }
  }, true); // O 'true' faz este bloqueio acontecer antes de qualquer outro script do site!

  var isInitializing = false;
  function initLightbox(callback) {
    if (isReady) {
      if (callback) callback();
      return;
    }
    if (isInitializing) return;
    isInitializing = true;
    
    if (!document.querySelector('.product__media-list')) return;
    
    loadStyle('https://cdnjs.cloudflare.com/ajax/libs/photoswipe/5.4.4/photoswipe.min.css');
    loadScript('https://cdnjs.cloudflare.com/ajax/libs/photoswipe/5.4.4/umd/photoswipe.umd.min.js', function() {
      loadScript('https://cdnjs.cloudflare.com/ajax/libs/photoswipe/5.4.4/umd/photoswipe-lightbox.umd.min.js', function() {
        prepareItems();
        isReady = true;
        isInitializing = false;
        if (callback) callback();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initLightbox(); });
  } else {
    setTimeout(function() { initLightbox(); }, 100);
  }
})();